import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-light text-text-light py-20 md:py-28 px-6" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 md:p-16 shadow-xl border border-accent/20 text-center relative overflow-hidden" data-id="element-152">
          {/* Decorative stars */}
          <div className="absolute top-6 left-6 text-accent/20" data-id="element-153">
            <Star className="w-8 h-8" fill="currentColor" data-id="element-154" />
          </div>
          <div className="absolute bottom-6 right-6 text-accent/20" data-id="element-155">
            <Star className="w-12 h-12" fill="currentColor" data-id="element-156" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif mb-12 text-dark-100" data-id="element-157">
            Lo que cambia en 7 días
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-12" data-id="element-158">
            <div className="space-y-2" data-id="element-159">
              <span className="block text-accent font-bold text-lg uppercase tracking-wider" data-id="element-160">
                Día 4
              </span>
              <p className="text-xl md:text-2xl font-serif text-dark-200" data-id="element-161">
                La mayoría de los bebés reducen sus despertares a la mitad.
              </p>
            </div>

            <div className="hidden md:block w-px h-24 bg-accent/30" data-id="element-162"></div>
            <div className="md:hidden h-px w-24 bg-accent/30" data-id="element-163"></div>

            <div className="space-y-2" data-id="element-164">
              <span className="block text-accent font-bold text-lg uppercase tracking-wider" data-id="element-165">
                Día 7
              </span>
              <p className="text-xl md:text-2xl font-serif text-dark-200" data-id="element-166">
                El{' '}
                <strong className="text-4xl text-dark-100 block mt-2" data-id="element-167">
                  85%
                </strong>{' '}
                de las madres reportan 6 horas seguidas.
              </p>
            </div>
          </div>

          <p className="text-lg text-text-light/80 max-w-2xl mx-auto italic" data-id="element-168">
            "Permitiendo que la madre recupere sus niveles de energía y
            paciencia."
          </p>
        </motion.div>
      </div>
    </section>;
}